import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import ProtectedRoute from '@/auth/ProtectedRoute';
import AdminRoute from '@/auth/AdminRoute';
import AppShell from '@/components/layout/AppShell';
import Login from '@/pages/Login';
import InviteLanding from '@/auth/InviteLanding';
import Home from '@/pages/Home';
import Cellar from '@/pages/Cellar';
import WineDetail from '@/pages/WineDetail';
import AddWine from '@/pages/AddWine';
import Recommend from '@/pages/Recommend';
import Profile from '@/pages/Profile';
import SharedLists from '@/pages/SharedLists';
import AdminPanel from '@/pages/AdminPanel';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/join" element={<InviteLanding />} />

          {/* Protected */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<Home />} />
              <Route path="/cellar" element={<Cellar />} />
              <Route path="/wine/:wineId" element={<WineDetail />} />
              <Route path="/add" element={<AddWine />} />
              <Route path="/recommend" element={<Recommend />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/lists" element={<SharedLists />} />
            </Route>

            {/* Admin only */}
            <Route element={<AdminRoute />}>
              <Route element={<AppShell />}>
                <Route path="/admin" element={<AdminPanel />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
